import axios from 'axios'
/**
 * axios 官方文档
 * http://www.axios-js.com/zh-cn/docs/
 */
var host = process.env.NODE_API_HOST
axios.defaults.withCredentials = true;// 携带cookie
export default (option) => {
    if (!option.method || option.method == "get") {
        option.params = option.data;
    }
    return new Promise((resolve, reject) => {
        axios(option).then((res) => {
            /**
             * 这里统一做res拦截
             */
            // if(res.errCode == 100119){
            //     window.location.href = host + '/wx/userLogin?callBackUrl=' + encodeURIComponent(window.location.href);
            //     return
            // }
            resolve(res.data)
        }).catch(() => {
            resolve(null)
        })
    });
}
